// extracted by mini-css-extract-plugin
export default {"steps":"CreateAdvertDialog_steps__epDk3"};